import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CompanyLicensingTabDataProviderFactory } from '../factory/CompanyLicensingTabDataProviderFactory';
import { CompanyLicensingTabBaseDataProvider } from '../dataProvider/CompanyLicensingTabBaseDataProvider';
import { CompanyData } from '../../../types/company-data';
import { User } from '../../../types/user';
import { CompanyLicenseInformation } from '../../../../license/types/CompanyLicenseInformation';

export class CompanyLicensingTabRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanyLicensingTabDataProviderFactory;
  public dataProvider: CompanyLicensingTabBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanyLicensingTabDataProviderFactory(),
    });
  }

  public async getMyCompanyData(): Promise<CompanyData> {
    return this.dataProvider.getMyCompanyData();
  }

  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    return this.dataProvider.getManagedCompanyById(companyId);
  }

  public async getLoggedUser(): Promise<User> {
    return this.dataProvider.getLoggedUser();
  }

  public async getCompanyLicenseInformation(editedCompanyId: string): Promise<CompanyLicenseInformation> {
    return this.dataProvider.getCompanyLicenseInformation(editedCompanyId);
  }
}
